import { connect } from 'react-redux';
import { hideHandoff } from '../../actionCreators';
import SidebarHandoff from '../../components/handoff/SidebarHandoff';
import { getSelectedElementType, isInHandoffMode, } from '../../selectors/handoff';
function mapStateToProps(state) {
    return {
        isOpen: isInHandoffMode(state),
        selectedElementType: getSelectedElementType(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onClose: function () {
            dispatch(hideHandoff());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SidebarHandoff);
